import React from "react";
import styles from "./style/answer_matrix.module.css";
import { useLanguage } from '../../functions/setGetLanguage';

const Answer_unique_handle = ({ choices, FunctionOnClickEnd , FunctionOnClickContinue}) => {
  const { language } = useLanguage();

  return (
    <div className={styles.choices}>
      {choices.map((choice, i) => (
        <button
          key={i}
          className={styles.choiceButton}
          onClick={() => choice.action ? FunctionOnClickEnd(choice) : FunctionOnClickContinue(choice)}
        >
          {choice[`text${language}`]}
        </button>
      ))}
    </div>
  );
};

export default Answer_unique_handle;
